export interface ContractStatus {
  isActive: boolean;
  isExpired: boolean;
  notStarted: boolean;
  daysRemaining: number | null;
  isExpiringSoon: boolean;
}

const toDay = (s: string) => {
  const [y, m, d] = s.slice(0, 10).split('-').map(Number);
  return Date.UTC(y, m - 1, d);
};

/** Vigencia del contrato Enterprise de una organización. Fechas null = sin límite. */
export function getContractStatus(
  start: string | null | undefined,
  end: string | null | undefined,
  today: Date = new Date(),
): ContractStatus {
  const t = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const notStarted = !!start && t < toDay(start);
  const isExpired = !!end && t > toDay(end);
  const daysRemaining = end ? Math.round((toDay(end) - t) / 86400000) : null;
  return {
    isActive: !notStarted && !isExpired,
    isExpired,
    notStarted,
    daysRemaining,
    isExpiringSoon: !isExpired && daysRemaining !== null && daysRemaining <= 30,
  };
}

export const formatContractDate = (s: string | null | undefined) =>
  s ? s.slice(0, 10).split('-').reverse().join('/') : '—';

/** Una licencia Enterprise solo da acceso si la empresa es Enterprise y su contrato está vigente. */
export function enterpriseLicenseGrantsAccess(input: {
  hasLicense: boolean;
  planTier: string | null | undefined;
  start: string | null | undefined;
  end: string | null | undefined;
  today?: Date;
}): boolean {
  if (!input.hasLicense || input.planTier !== 'enterprise') return false;
  return getContractStatus(input.start, input.end, input.today).isActive;
}
